var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page-wrapper rep-analytics-wrap"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('breadcrumb', {
    attrs: {
      "items": _vm.breadcrumbItems
    }
  }), _c('div', {
    staticClass: "page-title split rep-analysis-title justify-content-between"
  }, [_c('div', {}, [_vm.selectedGroupId ? _c('h1', {
    staticClass: "mb-0"
  }, [_vm._v("Group Analytics")]) : _c('h1', {
    staticClass: "mb-0"
  }, [_vm._v("Rep Analytics")])]), _c('div', {
    staticClass: "rep-selector"
  }, [_c('rep-selector'), _c('div', {
    staticClass: "d-flex align-items-center gap-2 direct-grp"
  }, [_c('label', {
    staticClass: "form-label mb-0 fit-content"
  }, [_vm._v("Downline Group")]), _c('multiselect', {
    attrs: {
      "name": "group",
      "placeholder": "Select Group",
      "options": _vm.groups.map(function (type) {
        return type.group_id;
      }),
      "custom-label": function customLabel(opt) {
        return _vm.groups.find(function (x) {
          return x.group_id == opt;
        }).group_name;
      },
      "options-limit": 100,
      "internal-search": false,
      "local-search": false
    },
    on: {
      "search-change": _vm.searchHandler,
      "open": _vm.getGroups
    },
    model: {
      value: _vm.selectedGroupId,
      callback: function callback($$v) {
        _vm.selectedGroupId = $$v;
      },
      expression: "selectedGroupId"
    }
  })], 1)], 1)]), _c('br'), _c('div', {
    staticClass: "downline"
  }, [_c('div', {
    staticClass: "page-title"
  }, [_vm.selectedGroupId ? _c('h5', [_vm._v(_vm._s(_vm.groupAnalyticsTitle) + " [ Downline Group ]")]) : _c('h5', [_vm._v("Downline Analytics")])]), _c('div', {
    staticClass: "row mb-3"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('DwNewMembersByMonth', {
    attrs: {
      "groupId": _vm.selectedGroupId
    },
    on: {
      "hide-loader": _vm.updateFlag
    }
  })], 1), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('DwOverallTotals', {
    attrs: {
      "groupId": _vm.selectedGroupId
    },
    on: {
      "hide-loader": _vm.updateFlag
    }
  })], 1), _c('br'), _c('div', {
    staticClass: "row"
  }, [_c('DwOverallTotalMembers', {
    attrs: {
      "groupId": _vm.selectedGroupId
    },
    on: {
      "hide-loader": _vm.updateFlag
    }
  })], 1)])]), _c('div', {
    staticClass: "row mb-5"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('DwEnrollmentsByMonth', {
    attrs: {
      "groupId": _vm.selectedGroupId
    },
    on: {
      "hide-loader": _vm.updateFlag
    }
  })], 1), _c('div', {
    staticClass: "col-md-5"
  }, [_c('DwOverallTotalPolicies', {
    attrs: {
      "groupId": _vm.selectedGroupId
    },
    on: {
      "hide-loader": _vm.updateFlag
    }
  })], 1), _c('div', {
    staticClass: "col-12"
  }, [_c('DwEnrollmentsTermsOverview', {
    attrs: {
      "groupId": _vm.selectedGroupId
    },
    on: {
      "hide-loader": _vm.updateFlag
    }
  })], 1)]), _c('div', {
    staticClass: "row mb-3 rep-analytics-third"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('DwTotalMembersByIndividualPlan', {
    attrs: {
      "groupId": _vm.selectedGroupId
    },
    on: {
      "hide-loader": _vm.updateFlag
    }
  })], 1), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('DwTotalActiveByState', {
    attrs: {
      "groupId": _vm.selectedGroupId
    },
    on: {
      "hide-loader": _vm.updateFlag
    }
  })], 1), _c('br'), _c('div', {
    staticClass: "row"
  }, [_c('DwTotalMembersByPlan', {
    attrs: {
      "groupId": _vm.selectedGroupId
    },
    on: {
      "hide-loader": _vm.updateFlag
    }
  })], 1)])])])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }